var React = require('react');

function IconPlus (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 12H16","stroke":"#0088BF","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12 8V16","stroke":"#0088BF","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

IconPlus.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconPlus;

IconPlus.default = IconPlus;
